import { api } from "./api";

import { TfaResponse, EnableTfaPayload } from "../../types/UserTypes";

export const tfaApi = api.injectEndpoints({
  endpoints: (builder) => ({
    initTfa: builder.mutation<TfaResponse, void>({
      query: (payload) => ({
        url: "/otps/",
        method: "POST",
        body: payload,
      }),
    }),
    enableTfa: builder.mutation<null, EnableTfaPayload>({
      query: (payload) => ({
        url: "/otps/enable/",
        method: "POST",
        body: payload,
      }),
    }),
    disableTfa: builder.mutation<null, { code?: string }>({
      query: ({ code }) => ({
        url: "/otps/disable/",
        method: "DELETE",
        headers: { "X-Archway-2fa": code },
      }),
    }),
  }),
});

export const {
  useInitTfaMutation,
  useDisableTfaMutation,
  useEnableTfaMutation,
} = tfaApi;
